import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Row, Col, Collapse } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { toggleLeftmenu } from "../../store/actions";

const Navbar = props => {
  useEffect(() => {
    var matchingMenuItem = null;
    var ul = document.getElementById("navigation");
    var items = ul.getElementsByTagName("a");
    for (var i = 0; i < items.length; ++i) {
      if (props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  });

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  }

  return (
    <React.Fragment>
      <div className='topnav'>
        <div className='container-fluid'>
          <nav className='navbar navbar-light navbar-expand-lg topnav-menu' id='navigation'>
            <Collapse isOpen={props.leftMenu} className='navbar-collapse' id='topnav-menu-content'>
              <ul className='navbar-nav'>
                <li className='nav-item dropdown'>
                  <Link
                    to='/staff-view'
                    className='nav-link'
                    onClick={() => {
                      props.toggleLeftmenu(!props.leftMenu);
                    }}>
                    <i className='bx bx-home-circle me-2'></i>
                    {props.t("Dashboard")}
                    {props.menuOpen}
                  </Link>
                </li>
                <li className='nav-item dropdown'>
                  <Link
                    to='/employee-documents-list'
                    className='nav-link'
                    onClick={() => {
                      props.toggleLeftmenu(!props.leftMenu);
                    }}>
                    <i className='bx bx-file me-2'></i>
                    {props.t("Documents")}
                  </Link>
                </li>
                <li className='nav-item dropdown'>
                  <Link
                    to='/trainings'
                    className='nav-link'
                    onClick={() => {
                      props.toggleLeftmenu(!props.leftMenu);
                    }}>
                    <i className='bx bx-link me-2' /> {props.t("Trainings")}
                  </Link>
                </li>
                <li className='nav-item dropdown'>
                  <Link
                    to='/privacy-policies'
                    className='nav-link'
                    onClick={() => {
                      props.toggleLeftmenu(!props.leftMenu);
                    }}>
                    <i className='bx bx-archive me-2' /> {props.t("Privacy Policy")}
                  </Link>
                </li>
                {/* <li className='nav-item dropdown'>
                  <Link
                    to='/employee-file-manager'
                    className='nav-link'
                    onClick={() => {
                      props.toggleLeftmenu(!props.leftMenu);
                    }}>
                    <i className='bx bx-file me-2' /> {props.t('Private Folder')}
                  </Link>
                </li> */}
                <li className='nav-item dropdown'>
                  <Link
                    to='/employee-availability'
                    className='nav-link'
                    onClick={() => {
                      props.toggleLeftmenu(!props.leftMenu);
                    }}>
                    <i className='bx bx-task me-2' /> {props.t("Availability")}
                  </Link>
                </li>
                <li className='nav-item dropdown'>
                  <Link
                    to='/visitor-register'
                    className='nav-link'
                    onClick={() => {
                      props.toggleLeftmenu(!props.leftMenu);
                    }}>
                    <i className='bx bx-book-bookmark me-2' /> {props.t("Visitors Register")}
                  </Link>
                </li>
                <li className='nav-item dropdown'>
                  <Link
                    to='/support-worker-time-sheet'
                    className='nav-link'
                    onClick={() => {
                      props.toggleLeftmenu(!props.leftMenu);
                    }}>
                    <i className='bx bx-receipt me-2' /> {props.t("Time Sheet")}
                  </Link>
                </li>
                <li className='nav-item dropdown'>
                  <Link
                    to='/support-worker-complaint'
                    className='nav-link'
                    onClick={() => {
                      props.toggleLeftmenu(!props.leftMenu);
                    }}>
                    <i className='bx bx-message-square-dots me-2' /> {props.t("Feedback")}
                  </Link>
                </li>
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(connect(mapStatetoProps, { toggleLeftmenu })(withTranslation()(Navbar)));
